import '../static/SectionWrap.css';
import React__default, { forwardRef } from "react";
import clsx from "clsx";
import { u as useTagName } from "./useTagName.COq0HFfN.mjs";
import { a as Container } from "./Container.CXMIxriX.mjs";
const sectionWrap = `_sectionWrap_0c86351`;
const offsetTop = `_offsetTop_a6dcb6b`;
const paddingBottom = `_paddingBottom_a00c141`;
const container = `_container_a930812`;
const clip = `_clip_04cd1b0`;
const neutral = `_neutral_f52b72d`;
const white = `_white_eabc3da`;
const styles = { sectionWrap, offsetTop, paddingBottom, container, clip, neutral, white };
const SECTION_WRAP_THEMES = ["white", "neutral"];
const SectionWrap = forwardRef(
  ({
    as = "section",
    children,
    className,
    containerSize,
    offsetTop: offsetTop2 = false,
    paddingBottom: paddingBottom2 = true,
    theme = "neutral",
    xAlign = "center",
    ...props
  }, ref) => {
    const Component = useTagName(as);
    return /* @__PURE__ */ React__default.createElement(
      Component,
      {
        "data-theme": theme,
        "data-padding-bottom": paddingBottom2,
        className: clsx(
          styles.sectionWrap,
          styles[theme],
          {
            [styles.paddingBottom]: paddingBottom2,
            [styles.offsetTop]: offsetTop2
          },
          className
        ),
        ref,
        ...props
      },
      /* @__PURE__ */ React__default.createElement(
        "svg",
        {
          className: styles.clip,
          "aria-hidden": "true",
          viewBox: "0 0 1280 200",
          fill: "currentColor",
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "none"
        },
        /* @__PURE__ */ React__default.createElement("path", { d: "M-606.4 0H-860v200h3000V0h-253.6A3996.6 3996.6 0 0 1 640 198 3997 3997 0 0 1-606.4 0z" })
      ),
      /* @__PURE__ */ React__default.createElement(
        Container,
        {
          "data-ui-section-container": true,
          xAlign,
          className: styles.container,
          size: containerSize
        },
        children
      )
    );
  }
);
export {
  SECTION_WRAP_THEMES as S,
  SectionWrap as a
};
//# sourceMappingURL=SectionWrap.DExzuSui.mjs.map
